import {
  type OfferSellerV1,
  type OfferV11,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../global-config'
import { TENANTS_WITH_MARKETPLACE_FUNCTIONALITY } from '../../../../marketplace'
import { productAccessorIsSaeOffer } from '../../../model/productAccessor/productAccessorIsSaeOffer'
import { productAccessorOfferHasSeller } from '../../../model/productAccessor/productAccessorOfferHasSeller'
import { productAccessorVariantHasOffers } from '../../../model/productAccessor/productAccessorVariantHasOffers'
import { useProductPageContext } from '../../productPageContext'

type SellerBoxProps = {
  offerSeller: OfferSellerV1 | undefined
  shouldRenderSellerBox: boolean
}

/**
 * Checking if the offer has a seller
 */
const doesOfferHasSeller = (offer: OfferV11 | null): boolean =>
  offer !== null && productAccessorOfferHasSeller(offer)

const shouldRenderSellerBox = (
  isMarketplace: boolean,
  currentVariant: PimProductV11,
  offer: OfferV11 | undefined,
): boolean => {
  if (!offer) {
    return false
  }

  return (
    isMarketplace &&
    productAccessorVariantHasOffers(currentVariant) &&
    doesOfferHasSeller(offer) &&
    !productAccessorIsSaeOffer(offer)
  )
}

export const useProductSellerBox = (): SellerBoxProps => {
  const { tenant } = useGlobalConfigContext()
  const { currentOffer, currentVariant } = useProductPageContext()

  const isMarketplace = TENANTS_WITH_MARKETPLACE_FUNCTIONALITY.has(tenant)

  return {
    offerSeller: currentOffer?.seller,
    shouldRenderSellerBox: shouldRenderSellerBox(
      isMarketplace,
      currentVariant,
      currentOffer,
    ),
  }
}
